import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import TextField from "@mui/material/TextField";
import AppPaths from "components/AppPaths";
import "./TagSongsTable.css";

const TagSongsTable = ({ songs = [], onRemoveSong, onAddSong }) => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  const [filter, setFilter] = useState("");

  const requestSort = (key) => {
    if (sortConfig.key === key) {
      if (sortConfig.direction === "ascending") {
        setSortConfig({ key, direction: "descending" });
      } else if (sortConfig.direction === "descending") {
        setSortConfig({ key: null, direction: null });
      } else {
        setSortConfig({ key, direction: "ascending" });
      }
    } else {
      setSortConfig({ key, direction: "ascending" });
    }
  };

  const sortedSongs = [...songs];
  if (sortConfig.key) {
    sortedSongs.sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key])
        return sortConfig.direction === "ascending" ? -1 : 1;
      if (a[sortConfig.key] > b[sortConfig.key])
        return sortConfig.direction === "ascending" ? 1 : -1;
      return 0;
    });
  }

  const filteredSongs = sortedSongs.filter(
    (s) =>
      s.name.toLowerCase().includes(filter.toLowerCase()) ||
      (s.content && s.content.toLowerCase().includes(filter.toLowerCase()))
  );

  return (
    <div className="tag-songs-table-container">
      <div className="tag-songs-table-header">
        <TextField
          label="Filtruj"
          fullWidth
          margin="dense"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        />
        {onAddSong && (
          <Button
            color="success"
            variant="contained"
            size="small"
            onClick={onAddSong}
          >
            Dodaj
          </Button>
        )}
      </div>
      <Table className="songs-table">
        <TableHead>
          <TableRow>
            <TableCell className="sortable-header" onClick={() => requestSort("id")}>
              ID
              {sortConfig.key === "id" && (
                <Icon style={{ fontSize: "0.75rem", verticalAlign: "middle" }}>
                  {sortConfig.direction === "ascending" ? "arrow_upward" : "arrow_downward"}
                </Icon>
              )}
            </TableCell>
            <TableCell className="sortable-header" onClick={() => requestSort("name")}>
              Tytuł
              {sortConfig.key === "name" && (
                <Icon style={{ fontSize: "0.75rem", verticalAlign: "middle" }}>
                  {sortConfig.direction === "ascending" ? "arrow_upward" : "arrow_downward"}
                </Icon>
              )}
            </TableCell>
            <TableCell>Akcje</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredSongs.map((song) => (
            <TableRow key={song.id}>
              <TableCell>{song.id}</TableCell>
              <TableCell>
                <a
                  href={AppPaths.SONG_WITH_ID(song.id)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="song-link"
                >
                  {song.name}
                </a>
              </TableCell>
              <TableCell className="songs-modal-actions">
                <div className="songs-modal-actions-container">
                  {onRemoveSong && (
                    <Button color="success" variant="contained" size="small" onClick={() => onRemoveSong(song)}>
                      Usuń
                    </Button>
                  )}
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default TagSongsTable;
